import React from 'react'
import { useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import {
  Box,
  Grid
} from '@material-ui/core'

import FullPageLoader from '~/components/fullpage-loader/fullpage-loader'
import Header from '~/components/header'

export default function DefaultLayout ({ children }) {
  const location = useLocation()
  const classes = useStyles({ alignCenter: (location.pathname === '/') })()

  return (
    <div className={classes.Wrapper}>
      <div className={classes.ContentContainer}>
        <React.Suspense fallback={<FullPageLoader />}>
          <Grid container direction='column' wrap='nowrap'>
            <Grid item>
              <Header />
            </Grid>
            <Grid item xs className={classes.Content}>
              <Box p={5} className={classes.Wrap}>
                {children}
              </Box>
            </Grid>
          </Grid>
        </React.Suspense>
      </div>
    </div>
  )
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired
}

const useStyles = props => makeStyles((theme) => ({
  Wrapper: {
    height: '100%',
    backgroundColor: theme.palette.background.default
  },
  ContentContainer: {
    display: 'flex',
    position: 'relative',
    height: '100vh'
  },
  Content: {
    display: 'flex',
    justifyContent: 'center'
  },
  Wrap: {
    display: 'flex',
    maxWidth: 1040,
    width: '100%',
    flex: 1,
    alignItems: (props.alignCenter ? 'center' : 'flex-start')
  }
}))
